import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

type ButtonSize = "large" | "medium" | "small" | "block";
type ButtonType = "main" | "warning" | "black";
interface Props {
  size?: ButtonSize;
  type?: ButtonType;
  isSecondary?: true;
  disabled?: boolean;
  text?: string | number | React.ReactNode;
  onClick?: any;
}
interface StyleProps {
  size?: ButtonSize;
  btnType?: ButtonType;
  disabled?: boolean;
}
const StyledPrimaryButton = styled.button<StyleProps>`
  box-shadow: none;
  cursor: pointer;
  border: 1px solid black;
  align-items: center;
  border-radius: 4px;
  white-space: nowrap;
  color: white;
  display: flex;
  justify-content: center;
  align-content: center;
  transition: all 0.3s;
  ${({ size }) => {
    switch (size) {
      case "small":
        return ` 
        height: 24px;
        font-size: 12px;
        line-height: 18px;
        padding: 3px 12px;
        `;
      case "medium":
        return `  
        height: 32px;
        font-size: 14px;
        line-height: 24px;
        padding:4px 16px;
        `;
      case "large":
        return `  
        height: 40px;
        font-size: 16px;
        line-height: 24px;
        padding: 8px 18px;`;
      case "block":
        return `
          height:100%;
          width:100%;
          font-size: 20px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: center;
          
          `;
      default:
        return `  height: 32px;
        `;
    }
  }}
  ${({ btnType }) => {
    switch (btnType) {
      case "black":
        return `
        background:${theme.colors.gray1};
        border-color:${theme.colors.gray1};
        &:hover{
          background:${theme.colors.blue1};
          border-color:${theme.colors.blue1};
        }
        &:active{
          background:${theme.colors.blue2};
          border-color:${theme.colors.blue2};
        }
        `;
      case "main":
        return `background: ${theme.colors.mainPrimary3};
        border-color:${theme.colors.mainPrimary3};
       
        &:hover{
          background: ${theme.colors.mainPrimary6};
          border-color: ${theme.colors.mainPrimary6};
        }
        &:active{
          background:${theme.colors.mainPrimary2};
          border-color:${theme.colors.mainPrimary2};
        }`;
      case "warning":
        return `background: ${theme.colors.red3};
   
        border-color:${theme.colors.red3};
      
        &:hover{
          background: ${theme.colors.red2};
          border-color:${theme.colors.red2};
        }
        &:active{
          background: ${theme.colors.red1};
          border-color:${theme.colors.red1};
        }`;
      default:
        return `background: #5E3FF7;
      
        &:hover{
          background: #A677FD;
        }
        &:focus{
          background: #4A14B0;
        }`;
    }
  }}
  ${({ disabled }) =>
    disabled === true
      ? `
      background-color:${theme.colors.gray9};
          border-color:${theme.colors.gray9};
          color:${theme.colors.gray6};
          cursor:not-allowed;
          &:hover{
            background-color:${theme.colors.gray9};
            border-color:${theme.colors.gray9};
            color:${theme.colors.gray6};
            cursor:not-allowed;
          }
          &:active{
            background-color:${theme.colors.gray9};
            border-color:${theme.colors.gray9};
            color:${theme.colors.gray6};
            cursor:not-allowed;
          }
      `
      : `;`};
`;

const StyledSecondaryButton = styled.button<StyleProps>`
  box-shadow: none;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  background: white;
  transition: all 0.3s;
  color: ${theme.colors.mainPrimary3};
  ${({ size }) => {
    switch (size) {
      case "small":
        return ` height: 24px;
        font-size: 12px;
        line-height: 18px;
        padding:3px 12px;
        `;
      case "medium":
        return `  height: 32px;
        font-size: 14px;
          line-height: 24px;
          padding: 4px 16px;
        `;
      case "large":
        return `  height: 40px;
        font-size: 16px;
        line-height: 24px;
        padding: 8px 18px;`;
      case "block":
        return `
            height:100%;
            width:100%;
            font-size: 20px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: center;
            
            `;
      default:
        return `  height: 32px
        `;
    }
  }}
  ${({ btnType }) => {
    switch (btnType) {
      case "black":
        return `
          color:${theme.colors.gray1};
          border-color:${theme.colors.gray6};
       
          &:hover{
            color:${theme.colors.gray1};
            border-color:${theme.colors.gray1};
          }
          &:active{
            background:${theme.colors.black};
            border-color:${theme.colors.black};
            color:white;
          }
          `;
      case "main":
        return `color: ${theme.colors.mainPrimary3};
          border-color:${theme.colors.mainPrimary3};
    
          &:hover{
            color: ${theme.colors.mainPrimary6};
            border-color:${theme.colors.mainPrimary6};
          }
          &:active{
            background:${theme.colors.mainPrimary3};
            border-color:${theme.colors.mainPrimary3};
            color:white;
          }`;
      case "warning":
        return `color: ${theme.colors.red3};
     
          border-color:${theme.colors.red3};
          &:hover{
            color: ${theme.colors.red2};
            border-color:${theme.colors.red2};
          }
          &:active{
            background: ${theme.colors.red1};
            border-color:${theme.colors.red1};
            color:white;
          }`;
      default:
        return ``;
    }
  }}
  ${({ disabled }) =>
    disabled === true
      ? `
   
  background-color:${theme.colors.gray9};
  border-color:${theme.colors.gray6};
  color:${theme.colors.gray6};
  cursor:not-allowed;
  &:hover{
    background-color:${theme.colors.gray9};
    border-color:${theme.colors.gray6};
    color:${theme.colors.gray6};
    cursor:not-allowed;
  }
  &:active{
    background-color:${theme.colors.gray5};
    border-color:${theme.colors.gray6};
    color:${theme.colors.gray6};
    cursor:not-allowed;
  }
    `
      : `;`};
`;
const Buttons: React.FC<Props> = ({
  size,
  type,
  isSecondary,
  disabled,
  text,
  onClick,
}) => {
  return isSecondary === undefined ? (
    <StyledPrimaryButton
      size={size || "medium"}
      type="button"
      btnType={type || "main"}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{text}</span>
    </StyledPrimaryButton>
  ) : (
    <StyledSecondaryButton
      size={size || "medium"}
      type="button"
      btnType={type || "main"}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{text}</span>
    </StyledSecondaryButton>
  );
};
export default Buttons;
